<template>
  <div
    v-if="isStaging"
    class="fixed top-0 left-0 z-50 bg-orange-500 text-white text-xs font-bold px-12 py-2 shadow-md transform -rotate-45 -translate-x-8 translate-y-4 origin-center"
  >
    STAGING
  </div>
  <div
    v-if="isStaging2"
    class="fixed top-0 left-0 z-50 bg-orange-500 text-white text-xs font-bold px-12 py-2 shadow-md transform -rotate-45 -translate-x-8 translate-y-4 origin-center"
  >
    NEW_PROD
  </div>
  <div
    v-if="isDev"
    class="fixed top-0 left-0 z-50 bg-indigo-700 text-white text-xs font-bold px-12 py-2 shadow-md transform -rotate-45 -translate-x-8 translate-y-4 origin-center"
  >
    LOCAL
  </div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';

const app = getCurrentInstance();
const config = app.appContext.config.globalProperties.$config;

const isStaging = computed(() => {
  return config.SERVER_URL && config.SERVER_URL.toLowerCase().includes('staging');
});

const isStaging2 = computed(() => {
  return config.SERVER_URL && config.SERVER_URL.toLowerCase().includes('app-api-dev');
});

const isDev = computed(() => {
  return config.SERVER_URL && config.SERVER_URL.toLowerCase().includes('localhost');
});
</script>
